<template>
  <div class="user-list-table">
    <el-table v-loading="loadingUsers"
              :data="data"
              :default-sort="defaultSort"
              @sort-change="onSortChange"
              style="width: 100%"
              :empty-text="emptyText"
              @row-click="onTableRowClick">
      <el-table-column
        :label="columnNames[0]"
        type="index"
        :index="rowTableIndex"
        width="70px">
      </el-table-column>
      <el-table-column
        width="50px">
        <template slot-scope="scope">
          <avatar :upic="scope.row.getUpic()"
                  :name="scope.row.getLastName()"
                  size="ic">
          </avatar>
        </template>
      </el-table-column>
      <el-table-column v-if="showExpand" type="expand" width="30">
        <user-detail slot-scope="scope"
                     :user="scope.row"
                     :isSuperAdmin="true">
        </user-detail>
      </el-table-column>
      <el-table-column
        :label="columnNames[1]"
        prop="last_name"
        :sortable="sortable && 'custom'"
        min-width="100">
        <template slot-scope="scope">
          {{scope.row.getLastName()}}
        </template>
      </el-table-column>
      <el-table-column
        :label="columnNames[2]"
        prop="first_name"
        :sortable="sortable && 'custom'"
        min-width="100">
        <template slot-scope="scope">
          {{scope.row.getFirstName()}}
        </template>
      </el-table-column>
      <el-table-column
        :label="columnNames[3]"
        prop="middle_name"
        :sortable="sortable && 'custom'"
        min-width="100">
        <template slot-scope="scope">
          {{scope.row.getMiddleName()}}
        </template>
      </el-table-column>
      <el-table-column
        :label="columnNames[4]"
        min-width="110">
        <template slot-scope="scope">
          <template v-if="scope.row.getPosts()">
            <posts-in-row :posts="scope.row.getPosts()"></posts-in-row>
          </template>
          <span v-else style="color: #C0C4CC">{{ $t('labels.not_specified1') }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!shortMode"
        :label="columnNames[5]"
        prop="status"
        :sortable="sortable && 'custom'"
        min-width="110">
        <template slot-scope="scope">
          <user-status v-if="scope.row && scope.row.getStatus()" :status="scope.row.getStatus()"></user-status>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!shortMode"
        :label="columnNames[7]"
        prop="msgrs"
        :sortable="sortable && 'custom'"
        min-width="110">
        <template slot-scope="scope">
          <msgrs-list v-if="scope.row.getMsgrs().length" :msgrs="scope.row.getMsgrs()" :scope="scope.row"></msgrs-list>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import avatar from 'src/components/Avatar/avatar.vue'
  import userStatus from '../UserStatus.vue'
  import superAdminIdent from 'src/components/SuperAdminIdent/SuperAdminIdent.vue'
  import userDetail from './userDetail.vue';
  import PostsInRow from 'src/components/Users/PostsInRow.vue'
  import msgrsList from '../Page/msgrsList.vue'

  // @ts-ignore
  import messages from '@/lang/index';

  const SUPER_ADMIN_NAME = 'superadmin'
  export default {
    name: 'UserTable',
    components: {avatar, userStatus, superAdminIdent, userDetail, PostsInRow, msgrsList},
    props: {
      loadingUsers: {
        type: Boolean,
        default: false
      },
      shortMode: {
        type: Boolean,
        default: false
      },
      emptyText: {
        type: String,
        default: messages.labels.no_data
      },
      data: {
        type: Array,
        default () { return [] }
      },
      defaultSort: {
        type: Object,
        default () {
          return {}
        }
      },
      indexOffset: {
        type: Number,
        default: 0
      },
      showExpand: {
        type: Boolean,
        default: true
      },
      sortable: {
        type: Boolean,
        default: true
      },
    },
    data () {
      return {
        columnNames: ['№', this.$t('labels.surname'), this.$t('labels.name'), this.$t('labels.middle_name'), this.$t('labels.position'), this.$t('labels.cols.status'), this.$t('labels.last_activity'), this.$t('labels.cols.messengers')]
      }
    },
    methods: {
      hasWorkplases (data) {
        if (data && data.getOrgs()) {
          return true
        }
      },
      onSortChange (event) {
        let col = []
        if (event.prop) {
          col.push(event.prop)
          col.push(event.order === 'ascending' ? 1 : -1)
        }
        this.$emit('sort-change', col)
      },
      onTableRowClick (row, event, column) {
        this.$emit('row-click', row, event, column)
      },
      rowTableIndex (index) {
        return this.indexOffset + index + 1;
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "src/assets/sass/core";
.user-list-table {
  .department-summary .services-list & {
    margin-left: -30px;
    margin-right: -30px;
    @include respond-to(phone){
      margin-left: -15px;
      margin-right: -15px;
    }
  }
}
</style>